import {createAction} from 'redux-actions';
import * as ACTION from './../constants';

export const createByBarcode = createAction(ACTION.CREATE_PACKAGE_BY_SCAN.REQUEST, (params) => params);
export const beginCreateAlonePackage = createAction(ACTION.BEGIN_CREATE_ALONE_PACKAGE, (idWarehouse) => (idWarehouse));

